export const hasPermission = {
    install (Vue) {
        Vue.directive('hasPermission', {
            bind (el, binding, vnode) {
                const permissionsNameList = JSON.parse(sessionStorage.getItem("permission"));
                const permissions = permissionsNameList
                const value = binding.value
                let flag = true
                for (const v of value) {
                    if (!permissions.includes(v)) {
                        flag = false
                    }
                }
                if (!flag) {
                    if (!el.parentNode) {
                        el.style.display = 'none'
                    } else {
                        el.parentNode.removeChild(el)
                    }
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/utils/permissionButton.js